import React from "react";
import { useAuth } from "../../../contexts/authContext";

export const ActionCard = ({ onOpenModal, onOpenConfiguration }) => {
	const { currentUser } = useAuth();

	const handleOpenModal = () => {
		onOpenModal(true);
	};

	const handleOpenConfiguration = () => {
		onOpenConfiguration(true);
	};

	return (
		<div className="w-full p-4 text-center bg-white border border-gray-200 rounded-lg shadow-sm sm:p-8 dark:bg-gray-800 dark:border-gray-700">
			<h5 className="mb-2 text-3xl font-bold text-gray-900 dark:text-white">
				{/* <span className="text-transparent bg-clip-text bg-gradient-to-r to-yellow-400 from-amber-600">{currentUser.displayName}</span> */}
				Include Your Fans In Your Music Journey
			</h5>
			<p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">
				Have an existing fan base? Click the button below and let's add your first one. <br />
				Building your fan base? Generate a fan lead form.
			</p>
			<div className="items-center justify-center sm:flex sm:space-x-2">
				<button
					onClick={handleOpenModal}
					type="button"
					className="border text-fuchsia-500 hover:text-violet-700 border-fuchsia-500 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2">
					Add Your First Fan
				</button>
				<button
					onClick={handleOpenConfiguration}
					type="button"
					className="border text-fuchsia-500 hover:text-violet-700 border-fuchsia-500 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2">
					Generate Fan Lead Form
				</button>
			</div>
		</div>
	);
};
